import {useEffect} from 'react'
import {jwtDecode} from 'jwt-decode'
import {useAuth} from '../core/Auth'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import Swal from 'sweetalert2'
import {DEFAULT_ERROR_MODAL} from '../../../constants/errors/error-model'
import {loginAD} from '../core/_requests'
import {useNavigate} from 'react-router-dom'

export function LoginAdTokenHandler() {
  const {saveAuth, setCurrentUser} = useAuth()
  const navigate = useNavigate()

  if (window.location.hash) {
    // window.location.href = '/auth/ad-token-handle'
    // Remove the hash from the URL
    window.history.replaceState(null, '', window.location.pathname + window.location.search)
    // Refresh the page
    window.location.reload()
  }
  useEffect(() => {
    const adToken = getAndClearAdToken()
    console.log('adToken', adToken)
    sendTokenToAimsTagApi(adToken?.secret || '')
  }, [])

  const getAndClearAdToken = () => {
    let adToken: any

    for (const key in localStorage) {
      if (key.includes('accesstoken')) {
        adToken = JSON.parse(localStorage[key])

        break
      }
    }

    return adToken as any
  }

  const sendTokenToAimsTagApi = async (adToken: string) => {
    console.log('sendTokenToAimsTagApi')
    try {
      if (adToken) {
        //TODO handle api response
        const {data: auth} = await loginAD(adToken)
        localStorage.clear()
        localStorage.setItem('accessToken', auth.data.token)
        localStorage.setItem('refreshToken', auth.data.refreshToken)
        let decoded = jwtDecode(auth.data.token) as any
        decoded = {...decoded, api_token: auth.data.token}

        saveAuth(decoded)
        setCurrentUser(decoded)
        window.location.href = '/'
      } else {
        navigate('/auth/login')
      }
    } catch (error: any) {
      console.error(error)
      saveAuth(undefined)
      await Swal.fire(DEFAULT_ERROR_MODAL(error.response.data.message))
      navigate('/auth/login')
    }
  }

  return (
    <>
      <div id='splash-screen' className='ad-page-loading'>
        <img
          src={toAbsoluteUrl('/media/logos/logo-tag.png')}
          className='light-logo'
          alt='Metronic light logo'
        />
        <span>Loading ...</span>
      </div>
    </>
  )
}
